import SvgIcon from './SvgIcon';

export { SvgIcon };

export default SvgIcon;
